/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductMaterialResponseDto>;
export function request(
  body: defs.basics.ProductMaterialRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaterial/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
